import {
  utils as commonUtils,
  finleyAssertUnreachable,
} from '@finley-technologies/common';
import { Explo } from '@finley-technologies/finley-types';

export const isCreditFacilityPlacement = (
  placement: Explo.ExploPlacement.AllOptionsType,
): boolean => {
  return Explo.ExploPlacement.CreditFacilityOptions.includes(placement);
};

export const isOrganizationPlacement = (
  placement: Explo.ExploPlacement.AllOptionsType,
): boolean => {
  return Explo.ExploPlacement.OrganizationOptions.includes(placement);
};

export const generateMissingIntegrationMessage = (params: {
  exploArtifactType: Explo.ExploArtifactType;
  exploPlacement: Explo.ExploPlacement.AllOptionsType;
}): string => {
  const { exploArtifactType, exploPlacement } = params;
  const stratsType = commonUtils.toTitleCase(exploArtifactType);
  switch (exploPlacement) {
    case 'borrowerStratsPage':
    case 'lenderFacilitiesTab':
      return `Strats ${stratsType} has not been set up for this credit facility. Please contact your Customer Sales Manager to explore additional features.`;
    case 'lenderPortfolioTab':
      return `Portfolio ${stratsType} has not been set up for this organization. Please contact your Customer Sales Manager to explore additional features.`;
    default:
      return finleyAssertUnreachable(exploPlacement);
  }
};
